module.exports = "../../app/cells/components/campaigns/widgets/brand_cell.rb";